import React from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card.jsx';
import { useEmbeddedNavigation } from '../hooks/useEmbeddedMode.js';
import SiteFooterLinks from './SiteFooterLinks.jsx';

export function StaticSection({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold text-ptcm-ink">{title}</h2>
      <div className="space-y-3 text-sm leading-7 text-ptcm-muted">
        {children}
      </div>
    </section>
  );
}

export default function StaticPageLayout({
  eyebrow,
  title,
  description,
  lastUpdated,
  children
}) {
  const { navigateEmbedded } = useEmbeddedNavigation();

  return (
    <div className="max-w-4xl mx-auto mt-6 px-3 sm:px-4 pb-16 space-y-6">
      <Card className="overflow-hidden">
        <CardHeader className="space-y-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div className="space-y-3">
              {eyebrow ? <div className="ptcm-section-pill w-fit">{eyebrow}</div> : null}
              <div className="space-y-2">
                <CardTitle className="text-2xl sm:text-3xl">{title}</CardTitle>
                <CardDescription className="max-w-2xl text-base">
                  {description}
                </CardDescription>
                {lastUpdated ? (
                  <p className="text-xs font-medium uppercase tracking-[0.14em] text-ptcm-muted">
                    Mise a jour: {lastUpdated}
                  </p>
                ) : null}
              </div>
            </div>

            <Button
              variant="outline"
              size="md"
              className="sm:shrink-0"
              onClick={() => navigateEmbedded('/')}
            >
              Retour a l'accueil
            </Button>
          </div>
        </CardHeader>

        <CardContent className="space-y-8">
          {children}
        </CardContent>
      </Card>

      <SiteFooterLinks centered />
    </div>
  );
}
